import { getRouteApi } from "@tanstack/react-router";
import { Search } from "lucide-react";
import { useEffect, useState } from "react";
import { useDebounce } from "react-use";
import { type UserFilters } from "./Filters";
import { cleanFilters } from "./utils";
import { Input } from "@/components/ui/input";

interface SearchFilterProps {
  disabled?: boolean;
}

export function SearchFilter({ disabled = false }: SearchFilterProps) {
  const navigate = getRouteApi("/(authed)/_layout/settings/users").useNavigate();
  const searchParams = getRouteApi("/(authed)/_layout/settings/users").useSearch();
  const [searchTerm, setSearchTerm] = useState(searchParams.search || "");

  // Sync with external URL changes (e.g., clear all filters, browser back/forward)
  useEffect(() => {
    setSearchTerm(searchParams.search || "");
  }, [searchParams.search]);

  // Debounce URL updates
  useDebounce(
    () => {
      const updatedFilters: UserFilters = {
        ...searchParams,
        search: searchTerm || undefined,
      };
      const cleanedFilters = cleanFilters(updatedFilters);
      void navigate({ search: cleanedFilters });
    },
    500,
    [searchTerm],
  );

  return (
    <div className="relative flex-1 max-w-sm">
      <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
      <Input
        placeholder="Search users..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        className="pl-10"
        disabled={disabled}
      />
    </div>
  );
}
